import React from "react";
import classNames from "classnames";
import { Controller, useFormContext } from "react-hook-form";
import { DateInput, FormSelect } from "../../forms";
import { BooleanSelect, ClientProjectSelect, DocumentTypesSelect, DocumentFunctionsSelect, GenericUserSelect } from "../../forms/selects";
import { GenericAdviserSelect, ServiceAgreementsSelect } from "./../../../components/forms/selects";

export const CompletedReviewFilterForm = ({ }) => {
    
    const { control, setValue, watch } = useFormContext();
    
    return (
        <div className="row gy-2">
            <div className="col-6">
                <Controller
                    name="reviewDateStart"
                    control={control}
                    render={({ field: { ref, value, onBlur, ...rest } }) => (
                        <DateInput
                            label="Review Date From"
                            isClearable
                            disableAnimations={true}
                            value={value}
                            onBlur={(value, _) => setValue("reviewDateStart", value, { shouldDirty: true })}
                        />
                    )}
                />
            </div>
            <div className="col-6">
                <Controller
                    name="reviewDateEnd"
                    control={control}
                    render={({ field: { ref, value, onBlur, ...rest } }) => (
                        <DateInput
                            label="Review Date To"
                            isClearable
                            disableAnimations={true}
                            value={value}
                            onBlur={(value, _) => setValue("reviewDateEnd", value, { shouldDirty: true })}
                        />
                    )}
                />
            </div>
            <div className="col-6">
                <Controller
                    name="serviceTermIds"
                    control={control}
                    render={({ field: { ref, value, onBlur, ...rest } }) => (
                        <ServiceAgreementsSelect
                            label="Service Terms"
                            isMulti={true}
                            defaultValue={value}
                            disableAnimations={true}
                            onBlur={(values) =>
                                setValue(
                                    "serviceTermIds",
                                    values.map((el) => el.value)
                                )
                            }
                        />
                    )}
                />
            </div>
            <div className="col-6">
                <Controller
                    name="adviserIds"
                    control={control}
                    render={({ field: { ref, value, onBlur, ...rest } }) => (
                        <GenericAdviserSelect
                            label="Adviser"
                            isMulti={true}
                            defaultValue={value}
                            disableAnimations={true}
                            onBlur={(values) =>
                                setValue(
                                    "adviserIds",
                                    values.map((el) => el.value)
                                )
                            }
                        />
                    )}
                />
            </div>
            <div className="col-6">
                <Controller
                    name="completedTaskStandard"
                    control={control}
                    render={({ field: { ref, value, onBlur, ...rest } }) => (
                        <FormSelect
                            isClearable
                            isMulti
                            options={[
                                {label: "Optimum", value: 0},
                                {label: "Acceptable", value: 1},
                                {label: "Missed Standard", value: 2},
                            ]}
                            label="Standards"
                            defaultValue={value}
                            disableAnimations={true}
                            onBlur={(values) =>
                                setValue(
                                    "completedTaskStandard",
                                    values.map((el) => el.value)
                                )
                            }
                        />
                    )}
                />
            </div>
        </div>
    );
};